const initialState = {
    statusShow: false,
    loader: false,
    offset: 0,
    contents: [],
    total_rows: 0,
};
const modalMyOrders = (state = initialState, action) => {
    switch (action.type) {
        case 'OPEN_MODAL_MY_ORDERS':
            return {...state, statusShow: true};
        case 'CLOSE_MODAL_MY_ORDERS':
            return {...state, statusShow: false};
        case 'CHANGE_LOADER_MODAL_MY_ORDERS':
            return {...state, loader: action.loader};
        case 'CHANGE_DATA_MY_ORDERS':
            return {
                ...state,
                contents: action.contents,
                total_rows: action.total_rows,
                offset: action.offset
            };
        case 'CHANGE_TEXT_SURVEY_REAL_TIME':
            return {...state,
                contents: state.contents.map(item => item.id === action.id ? {
                    ...item,
                    poll_message: action.text,
                    poll_status: false
                } : item)
            };
        default:
            return state;
    }
};

export default modalMyOrders;